import { useEffect, useMemo } from 'react';
import styles from './salesPeriod.module.scss';
import Chart from "react-apexcharts";
import { SalesPeriodDashboardProps } from '../../../../interfaces/components'
import { useToast } from '../../../../helpers/hooks';
import { addPointsInText, numberFormatter } from '../../../../helpers/app';
import moment from 'moment';
import { CircularProgress, Skeleton } from '@mui/material';

const SalesPeriod = ({
    user,
    branch,
    getSalesPeriod,
    cleanSalesPeriod,
    salesPeriod,
    date,
    className
}: SalesPeriodDashboardProps) => {
    const toast = useToast();

    const dataNormalized: any = useMemo(() => {
        let data = [0, 100];
        if(salesPeriod?.data?.publications && (!(salesPeriod?.data?.publications?.total_quantity === 0 || salesPeriod?.data?.sales?.total_quantity === 0))){
            data = [salesPeriod?.data?.sales?.total_quantity, salesPeriod?.data?.publications?.total_quantity];
        }
        return data;
    }, [salesPeriod?.data]);

    useEffect(() => {
        if(salesPeriod?.fetching === "failure"){
            if(salesPeriod?.error){
                toast("Ha ocurrido un error al mostrar las ventas del periodo seleccionado");
            }
            cleanSalesPeriod();
        }
        if(salesPeriod?.fetching === "success"){
            cleanSalesPeriod();
        }
    }, [salesPeriod?.fetching]);
    
    useEffect(() => {
        if(!!date?.start.length && !!date?.end.length && (user?.branch || branch !== "")){
            getSalesPeriod(date?.start, date?.end);
        }
    }, [date, branch]);

    return(
        <div className={`${styles.salesPeriod} ${className}`}>
                <div className={styles.info}>
                    {
                        !date?.start || !date?.end
                        ?
                            `Cargando información`
                        :
                            moment(date?.start).format('YYYY') === moment(date?.end).format('YYYY')
                            ?   <p className={styles.title}>Ventas desde {moment(date?.start).format('DD MMM')} a {moment(date?.end).format('DD MMM')}</p>
                            :   <p className={styles.title}>Ventas desde {moment(date?.start).format('DD MMM YYYY')} a {moment(date?.end).format('DD MMM YYYY')}</p>
                    }
                    {
                        salesPeriod?.fetching === "loading" 
                        ? <Skeleton animation="wave" variant="text" className={`${styles.value} ${styles.skeleton}`} />
                        : <p className={styles.value}>${numberFormatter(salesPeriod?.data?.sales?.total_price, 1)}</p>
                    }
                    <p className={styles.subtitle}>
                        {   
                            salesPeriod?.fetching === "loading" 
                            ?   "Cargando ventas..."
                            :   `Se ${salesPeriod?.data?.sales?.total_quantity === 1 ? 'vendió' : 'vendieron'} ${addPointsInText(salesPeriod?.data?.sales?.total_quantity)} vehículo${(salesPeriod?.data?.sales?.total_quantity === 1) ? '' : 's'}`
                        }
                    </p>
                </div>
                <div className={styles.data}>
                    <Chart 
                        type="donut" 
                        series={dataNormalized} 
                        width="90px"
                        height="90px"
                        options={{
                            chart: {
                                parentHeightOffset: 0,
                                sparkline: {
                                    enabled: true,
                                }
                            },
                            plotOptions: {
                                pie: {
                                    expandOnClick: false,
                                    donut: {
                                        size: '50px'
                                    }
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            legend: {
                                show: false
                            },
                            tooltip: {
                                enabled: false
                            },
                            fill: {
                                colors: ['#4874D0', '#E4E8EF'],
                                opacity: 1
                            },
                            stroke: {
                                width: 0
                            },
                            states: {
                                hover: {
                                    filter: {
                                        type: 'none'
                                    }
                                },
                                active: {
                                    filter: {
                                        type: 'none',
                                    }
                                },
                            }
                        }}
                    />
                </div>
        </div>
    )
}

export default SalesPeriod;